<template>
  <a href="#" id="shopModal" @click.stop="showModal">店舗情報</a>

  <div v-if="show" class="modal-overlay shop-modal-overlay" @click.self="closeModal">
    <!-- pc -->
    <div class="shop_menu">
      <div class="shop_list">
        <a href="/shop?id=6">
          <div class="img"><img data-src="/assets/img/common/gourmet.svg" class="lazyload"></div>
          グルメ
        </a>
      </div>
      <div class="shop_list">
        <a href="/shop?id=36">
          <div class="img"><img data-src="/assets/img/common/bag.svg" class="lazyload"></div>
          ショッピング
        </a>
      </div>
      <div class="shop_list">
        <a href="/shop?id=31">
          <div class="img"><img data-src="/assets/img/common/beauty.svg" class="lazyload"></div>
          ビューティー
        </a>
      </div>
      <div class="shop_list">
        <a href="/shop?id=41">
          <div class="img"><img data-src="/assets/img/common/rental.svg" class="lazyload"></div>
          レンタル・サービス
        </a>
      </div>
      <div class="shop_list">
        <a href="/shop?id=20">
          <div class="img"><img data-src="/assets/img/common/yacht.svg" class="lazyload"></div>
          ツアー・アクティビティ
        </a>
      </div>
    </div>

    <!-- sp -->
    <div class="shop_sp_modal">
      <div class="box">
        <div class="header">
          <h2>選択してください</h2>
          <div class="close" @click="closeModal"></div>
        </div>
        <div class="contents">
          <a href="/shop?id=6" class="contents_list">
            <div class="img"><img data-src="/assets/img/common/gourmet.svg" class="lazyload"></div>グルメ
          </a>
          <a href="/shop?id=36" class="contents_list">
            <div class="img"><img data-src="/assets/img/common/bag.svg" class="lazyload"></div>ショッピング
          </a>
          <a href="/shop?id=31" class="contents_list">
            <div class="img"><img data-src="/assets/img/common/beauty.svg" class="lazyload"></div>ビューティー
          </a>
          <a href="/shop?id=41" class="contents_list">
            <div class="img"><img data-src="/assets/img/common/rental.svg" class="lazyload"></div>レンタル・サービス
          </a>
          <a href="/shop?id=20" class="contents_list">
            <div class="img"><img data-src="/assets/img/common/yacht.svg" class="lazyload"></div>ツアー・アクティビティ
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    show: false
  }),
  mounted() {},
  methods: {
    showModal() {
      this.show = true
      this.changeIndex(true)
    },
    closeModal() {
      this.show = false
      this.changeIndex()
    },
    changeIndex(flg) {
      let list = document.querySelector('#navList > li.active')
      if (list && flg) {
        if (!list.classList.contains('shopTab')) {
          list.style.zIndex = -1
        }
      } else {
        list.style.zIndex = 'auto'
      }
    }
  },
  watch: {
    show(val) {
      if (!val) return
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/media_query.scss';

#globalNav {
  .modal-overlay {
    @include sp {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .shop-modal-overlay {
    .shop_menu {
      @media screen and (max-width: 768px) {
        display: none;
      }
      @media screen and (min-width: 769px) {
        display: block;
      }
    }
    .shop_sp_modal {
      @include sp {
        flex-shrink: 0;
        width: 90%;
      }
      @media screen and (max-width: 768px) {
        display: block;
      }
      @media screen and (min-width: 769px) {
        display: none;
      }
    }
  }
}
</style>
